<template>
  <div class="content">
    <div class="w-1200 mail-box">
      <div class="header-box">
        <div class="word">
          <span class="bold-word">站内信息</span>
          <span class="desc">（共{{ total_count }}条,已读{{ is_read_count }}条）</span>
        </div>
        <div class="search">
          <div class="search-wrapper">
            <div class="search-input-container">
              <i class="el-icon-search search-icon"></i>
              <input
                  type="text"
                  class="search-input-field"
                  placeholder="请输入消息内容进行搜索..."
                  v-model="keyWord"
                  @keyup.enter="getSearchList"
                  @input="onSearchInput"
              />
              <i
                  v-if="keyWord"
                  class="el-icon-close clear-btn"
                  @click="clearSearch"
              ></i>
            </div>
            <button
                class="search-btn"
                @click="getSearchList"
                :disabled="!keyWord.trim()"
            >
              搜索
            </button>
          </div>
        </div>
      </div>
      <div class="body-box">
        <el-menu :default-active="activeName" background-color="#F5F5F5" class="el-menu-demo" mode="horizontal"
                 @select="handleClick">
          <el-menu-item index="0">全部</el-menu-item>
          <el-menu-item index="1">业务提醒</el-menu-item>
          <el-menu-item index="2">系统消息提醒</el-menu-item>
        </el-menu>

        <div class="tabs-box">
          <div class="plane-box" v-loading="loading">
            <div class="message-card" v-for="item in list" :key="item.id">
              <div class="message-head">
                <div>
                  <span class="title">
                    {{ item.title }}
                  </span>
                  <el-tag type="danger" size="small" v-if="item.is_read == 2">new</el-tag>
                </div>
                <span class="time-desc">{{ item.created_at }}</span>
              </div>
              <div class="message-body">
                {{ item.content }}
              </div>
              <div class="message-footer">
                <gradient-button border="1px solid #DCDCDC" :background="item.is_read == 2 ? '#0C60E6' : '#DCDCDC'" @hit="handleDetail(item)">查看详情</gradient-button>
              </div>
            </div>
            <el-pagination v-if="total > 0" class="pagination-box" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange" :current-page="page" :page-sizes="[20, 40, 60, 80]"
                           :page-size="limit" background layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
            <el-empty v-else></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GradientButton from "@/components/button/gradient-button.vue";
import {messageList, messageDetail} from "@/api/modules/user.js";

export default {
  name: "mail",
  components: {GradientButton},
  data() {
    return {
      total_count: 0,
      keyWord: "",
      activeName: "0",
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      is_read_count: 0,
    };
  },
  mounted() {
    this.getList();
    this.$store.dispatch('GET_USER_MESSAGE_COUNT');
  },
  methods: {
    getSearchList() {
      if (this.keyWord.trim() === "") {
        this.$message.warning({
          message: "请输入关键词",
          type: "warning",
          duration: 2000,
          offset: 300,
        });
        return;
      }
      this.page = 1;
      this.getList();
    },
    lockDetail(id) {
      messageDetail(id).then((res) => {
        this.detail = res.data.data;
      });
    },
    handleDetail(item) {
      this.$store.dispatch('GET_USER_MESSAGE_COUNT');
      switch (item.type) {
        case 1:
          this.lockDetail(item.id);
          this.$router.push({
            path: "/user/purchase/post",
            query: {
              id: item.id,
            },
          });
          break;
        case 3:
          this.lockDetail(item.id);
          this.$router.push({
            path: "/user/purchase/order",
            query: {
              id: item.id,
            },
          });
          break;
        case 6:
          this.lockDetail(item.id);
          this.$router.push({
            path: "/user/supplier/quotation",
            query: {
              id: item.id,
            },
          });
          break;
        case 7:
          this.lockDetail(item.id);
          this.$router.push({
            path: "/user/supplier/sale-order",
            query: {
              id: item.id,
            },
          });
          break;
        case 9:
          this.lockDetail(item.id);
          this.$router.push({
            path: "/user/base-info",
          });
          break;
        default:
          this.$router.push({
            path: "/user/message/mail-detail",
            query: {
              id: item.id,
            },
          });
          break;
      }
      this.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      messageList({
        page: this.page,
        limit: this.limit,
        status: this.activeName,
        keywords: this.keyWord,
      }).then((res) => {
        this.list = res.data.data.list.data;
        this.total_count = res.data.data.total_count;
        this.total = res.data.data.list.total;
        this.is_read_count = res.data.data.is_read_count;
        this.loading = false;
      });
    },
    handleClick(index) {
      this.activeName = index;
      this.page = 1;
      this.list = [];
      this.getList();
    },
    handleSizeChange(size) {
      this.limit = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getList();
    },
    onSearchInput() {
      if (this.keyWord.trim() === "") {
        this.getList();
      }
      // 当输入框内容变化时的处理逻辑
      // 可以在这里添加防抖搜索或其他实时搜索功能
    },
    clearSearch() {
      this.keyWord = "";
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.pagination-box {
  // margin-top: 20px;
  text-align: right;
}

::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

/*去掉tabs底部的下划线*/
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

.mail-box {
  padding: 0 0 20px;

  .body-box {

    .plane-box {
      padding-top: 20px;

      .message-card {
        padding: 20px 80px;
        background: #ffffff;
        margin-bottom: 30px;

        .message-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          border-bottom: 1px solid #d8d8d8;

          .title {
            display: inline-block;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            margin-right: 15px;
          }
        }

        .message-body {
          padding: 20px 0;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }

        .message-footer {
          display: flex;
          justify-content: flex-end;
        }

        .time-desc {
          font-weight: 400;
          font-size: 16px;
          color: #afafaf;
        }
      }
    }
  }

  .header-box {
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px;

    .bold-word {
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }

    .desc {
      display: inline-block;
      margin-left: 18px;
    }

    .search {
      width: 666px;

      .search-wrapper {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;

        .search-input-container {
          position: relative;
          flex: 1;
          min-width: 0;

          .search-icon {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #909399;
            font-size: 16px;
            z-index: 2;
            pointer-events: none;
          }

          .search-input-field {
            width: 100%;
            height: 44px;
            padding: 12px 40px 12px 44px;
            border: 2px solid #e4e7ed;
            border-radius: 8px;
            outline: none;
            font-size: 14px;
            background: #ffffff;
            transition: all 0.3s ease;
            box-sizing: border-box;

            &::placeholder {
              color: #c0c4cc;
              font-size: 14px;
            }

            &:focus {
              border-color: #409eff;
              box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
            }

            &:hover {
              border-color: #c0c4cc;
            }
          }

          .clear-btn {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #c0c4cc;
            cursor: pointer;
            font-size: 16px;
            transition: color 0.3s ease;
            z-index: 2;
            padding: 4px;
            border-radius: 50%;

            &:hover {
              color: #909399;
              background: rgba(144, 147, 153, 0.1);
            }
          }
        }

        .search-btn {
          height: 44px;
          padding: 0 24px;
          background: linear-gradient(135deg, #0C60E6 0%, #66b1ff 100%);
          color: #ffffff;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          white-space: nowrap;
          min-width: 80px;

          &:hover:not(:disabled) {
            background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
            transform: translateY(-1px);
          }

          &:active:not(:disabled) {
            transform: translateY(0);
          }

          &:disabled {
            background: #c0c4cc;
            cursor: not-allowed;
            box-shadow: none;
            transform: none;

            &:hover {
              background: #c0c4cc;
              box-shadow: none;
              transform: none;
            }
          }
        }
      }
    }
  }
}
</style>
